// Webstrap dependecies
//
require("webstrap/forms");

// jQuery Validation
//
require('imports-loader?define=>false&jQuery=jquery!jquery-validation/dist/jquery.validate.js');


// Localisation
//
require("./localization.js");


// Validation
//
require("./validation.js");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/forms-validation/index.js
 ** module id = 9
 ** module chunks = 0 1
 **/